/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  APIBasicClientServices,
  APIBasicQueryClientServices,
  APIDefaultQueryClientServices,
  APIUtilityClientServices,
  CreateAPIBasicClientOptions,
  CreateAPIBasicQueryClientOptions,
  CreateAPIClientOptions,
  CreateAPIQueryClientOptions,
} from '@openapi-qraft/react';
import { qraftAPIClient } from '@openapi-qraft/react';
import * as allCallbacks from '@openapi-qraft/react/callbacks/index';

import { services } from './services/index';

export function createAPIClient(options: CreateAPIQueryClientOptions): APIDefaultQueryClientServices<Services>;
export function createAPIClient(
  options: CreateAPIBasicQueryClientOptions
): APIBasicQueryClientServices<Services, AllCallbacks>;
export function createAPIClient(options: CreateAPIBasicClientOptions): APIBasicClientServices<Services, AllCallbacks>;
export function createAPIClient(): APIUtilityClientServices<Services, AllCallbacks>;
export function createAPIClient(
  options?: CreateAPIClientOptions
):
  | APIDefaultQueryClientServices<Services>
  | APIBasicQueryClientServices<Services, AllCallbacks>
  | APIBasicClientServices<Services, AllCallbacks>
  | APIUtilityClientServices<Services, AllCallbacks> {
  if (!options) return qraftAPIClient(services, allCallbacks);
  if ('requestFn' in options) return qraftAPIClient(services, allCallbacks, options);
  if ('queryClient' in options) return qraftAPIClient(services, allCallbacks, options);
  return qraftAPIClient(services, allCallbacks);
}
type AllCallbacks = typeof allCallbacks;
type Services = typeof services;
